module.exports = __webpack_public_path__ + "img/c++logo.9fbd7444.png";